import { render, staticRenderFns } from "./UiTabButton.vue?vue&type=template&id=75f53a98"
import script from "./UiTabButton.vue?vue&type=script&lang=js"
export * from "./UiTabButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports